<template>
    <span>
        <input
            type="text"
            class="form-control mb-2 user-item"
            :placeholder="'Người chơi ' + (index+1)"
            tabindex="0"
        />
        <div v-if="score_user_item.length > 0">
            <span v-for="(v, k) in score_user_item" :key="k">
                <input type="number" class="form-control mb-2" :placeholder="'Điểm số ' + (k + 1)" v-model="score_user_item[k]" />
            </span>
        </div>
        <div class="footer text-center mt-3">
            <h5>Tổng: {{ score_col_total }}</h5>
        </div>
    </span>
</template>
<script>
    export default {
        data() {
            return {
                
            };
        },
        props: ["score_user_item", "index"],
        computed: {
            score_col_total() {
                var total = 0;
                this.score_user_item.forEach(e => {
                    e = parseFloat(e);
                    if(!isNaN(e)) {
                        total += e
                    }
                });
                return total;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/ColUser.vue